module.exports = __webpack_public_path__ + "img/icon_map_2_on_100.fbf192f9.png";